import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { CodeAndName } from '@lx/shared/types';
import { Company, CompanyEnum } from '../../models/company.model';
import { HeaderFlagComponent } from '../header-flag/header-flag.component';
import { PriceListLinksComponent } from '../price-list-links/price-list-links.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-school-header',
  templateUrl: './school-header.component.html',
  styleUrls: ['./school-header.component.scss', './print-school-header.component.scss'],
  imports: [CommonModule, HeaderFlagComponent, PriceListLinksComponent],
})
export class SchoolHeaderComponent implements AfterContentInit {
  @Input() school = '';
  @Input() schoolDescription: string | undefined;
  @Input() publicHolidays = true;
  @Input() isPlus30 = false;
  @Input() country: CodeAndName | undefined;
  @Input() subtitle: string | undefined;
  @Input() disclaimer: string | undefined;
  @Input() company: Company = CompanyEnum.KIL;
  @Input() applicationForms = [];

  /**
   * Reference to a projected custom price list links template from the parent component.
   * If a parent provides an <ng-template #customPriceListLinks>, this property will hold its TemplateRef.
   * Used to determine if custom price list links should be rendered instead of the default links.
   * This enables flexible content projection and conditional rendering according to Angular best practices.
   */
  @ContentChild('customPriceListLinks') customPriceListLinksRef: TemplateRef<unknown> | undefined;

  protected customPriceListLinksPresent = false;

  ngAfterContentInit() {
    this.customPriceListLinksPresent = !!this.customPriceListLinksRef;

    // if the application forms contains a company field, filter the application forms to only include those that match the current company
    if (this.applicationForms.some((form) => form.company)) {
      this.applicationForms = this.applicationForms.filter((form) => form.company === this.company);
    }
  }
}
